export const setECQSWizardContext = (data) => ({
  type: "SET_CONTEXT",
  payload: data,
});
